export default {
  dreRevenueIncrementMetrics: {},
  dreOffersCouponsMetrics: {},
  dreProductsMetrics: {},
  dreClientsDistributionBefore: {},
  dreChannelsDistribution: {},
  dreAnalysedPeriod: '',
  hasDreOffersSchedulesResults: false,
  dreAnalyticConfigurations: [],
}
